import BestDealGuaranteeBanner from '../application/banners/bestDealGuaranteeBanner';
import RealSaleBanner from '../application/banners/realSaleBanner';
import RewardsWeekBanner, {
  RewardsWeekBannerProps,
} from '../application/banners/rewardsWeekBanner';
import SpotlightSaleBanner, {
  SpotlightSaleBannerProps,
} from '../application/banners/spotlightSaleBanner';

type Sales = {
  isRealSale: boolean;
  isRewardsWeekSale: boolean;
  isSpotlightSale: boolean;
};

type BannerProps =
  | {
      isSale?: boolean;
      text?: string;
    } & (SpotlightSaleBannerProps | RewardsWeekBannerProps);

export type VehicleSearchBannerProps = {
  bannerProps: BannerProps;
  sales: Sales;
};

const VehicleSearchBanner = ({
  sales,
  bannerProps,
}: VehicleSearchBannerProps) => {
  const { isRealSale, isSpotlightSale, isRewardsWeekSale } = sales;

  if (isRealSale) {
    const { isSale, text } = bannerProps;
    return <RealSaleBanner isSERPS isSale={isSale} text={text} />;
  }

  if (isSpotlightSale) {
    const { saving, variant } = bannerProps as SpotlightSaleBannerProps;
    return <SpotlightSaleBanner saving={saving} variant={variant} />;
  }

  if (isRewardsWeekSale) {
    const { saving, variant } = bannerProps as RewardsWeekBannerProps;
    return <RewardsWeekBanner saving={saving} variant={variant} />;
  }
  return <BestDealGuaranteeBanner />;
};

export default VehicleSearchBanner;
